import { z as zod } from "zod";
import { SurveyFieldOptionType, SurveyFieldType } from "@onair/repositories";

export const SurveyQuestionFormFieldSchema = zod
	.object({
		type: zod.enum(
			[
				SurveyFieldType.CHECKBOX,
				SurveyFieldType.RADIO,
				SurveyFieldType.RATING,
				SurveyFieldType.SELECT,
				SurveyFieldType.TEXTAREA,
			],
			{ message: "type khong hop le" },
		),
		label: zod.string().min(1, { message: "Vui lòng nhập câu hỏi" }),
		placeholder: zod.string(),
		required: zod.boolean(),
		options: zod.array(
			zod
				.object({
					id: zod.string().optional(),
					label: zod.string(),
					type: zod.enum(
						[SurveyFieldOptionType.DEFAULT, SurveyFieldOptionType.OTHER],
						{ message: "Type invalid" },
					),
				})
				.superRefine((values, context) => {
					if (values.type === SurveyFieldOptionType.DEFAULT && !values.label) {
						context.addIssue({
							code: zod.ZodIssueCode.custom,
							message: "Vui lòng nhập lựa chọn.",
							path: ["label"],
						});
					} else if (
						values.type === SurveyFieldOptionType.OTHER &&
						values.label
					) {
						context.addIssue({
							code: zod.ZodIssueCode.custom,
							message: "Vui lòng không nhập gì.",
							path: ["label"],
						});
					}
				}),
		),
		id: zod.string().optional(),
	})
	.superRefine((values, context) => {
		if (
			(values.type === SurveyFieldType.CHECKBOX ||
				values.type === SurveyFieldType.RADIO ||
				values.type === SurveyFieldType.SELECT) &&
			!values.options.length
		) {
			context.addIssue({
				code: zod.ZodIssueCode.custom,
				message: "Vui lòng thêm lựa chọn với loại câu hỏi này.",
				path: ["options"],
			});
		}
	});

export type SurveyFormActions = "Create" | "SoftCreate" | "Update";
export const SurveyFormSchema = zod
	.object({
		action: zod.enum(["Create", "SoftCreate", "Update"]),
		title: zod
			.string()
			.min(1, { message: "Vui lòng nhập tiêu đề" })
			.max(200, "Vui lòng nhập tối đa 200 ký tự"),
		description: zod.string(),
		banner: zod.string(),
		fields: zod.array(SurveyQuestionFormFieldSchema),
	})
	.superRefine((values, context) => {
		if (values.action === "Create" || values.action === "Update") {
			if (!values.fields.length) {
				context.addIssue({
					code: zod.ZodIssueCode.custom,
					message: "Thêm ít nhất 1 câu hỏi.",
					path: ["fields"],
				});
			}
		}
	});

export type CreateSurveyFormFields = zod.infer<typeof SurveyFormSchema>;
export type CreateSurveyQuestionFormFields = zod.infer<
	typeof SurveyQuestionFormFieldSchema
>;
